export default __webpack_public_path__ + "4aecee9914f445ec6020bb3d3210840e.ttf";